import {Button} from "@mui/material";
import classNames from "classnames";
import React, {useEffect, useState} from 'react';
import CheckIcon from '@mui/icons-material/Check';
import api from "../../api";
import s from './styles.module.css';

const Login = ({selectedValues, setSelectedValues, mainChooseHandler, setAuthData, authData}) => {

    const maxCoach = (maxValue) => Array.from({length: maxValue}, (v, k) => k++)

    useEffect(() => {
        const getAuthData = async () => {
            try {
                const res = await api().post('coach/coach_type')
                setAuthData(res.data)
            } catch (e) {
                console.log(e)
            }
        }

        const putVersion = async () => {
            const res = await api().get('coach/put_version/' + process.env.REACT_APP_VERSION);
            console.log(res);
        }

        getAuthData();
        putVersion();

    }, [])

    const updateCash = () => {

        if ('caches' in window) {
            caches.keys().then(names => Promise.all(names.map(name => caches.delete(name))));
        }

        const cleanUrl = window.location.origin + window.location.pathname;
        const newUrl = cleanUrl + '?v=' + Date.now();

        window.location.replace(newUrl);
        setTimeout(() => window.location.reload(), 300);
    };

    return (
        <div className={s.login}>
            <span style={{fontSize: '14px', alignSelf: 'end', position: 'absolute'}}>{process.env.REACT_APP_VERSION}</span>
            <div className={s.choose_name}>
                <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                    <h3>Выберите тип судьи</h3>
                    <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'space-between', alignItems: 'center'}}>
                        <button className={s.update_button} onClick={updateCash}>
                            <img src="/update.png" alt="update" style={{width: '40px', height: '40px'}}/>
                        </button>
                    </div>
                </div>
                <div className={s.choose_name_content}>
                    {authData?.coach_type?.map((el, i) => {
                        return <div
                            onClick={() => setSelectedValues({
                                ...selectedValues,
                                coach_type_id: el.coach_type_id,
                                coachMax: el.coach_type_count
                            })}
                            className={classNames(s.choose_name_item, selectedValues.coach_type_id === el.coach_type_id && s.active)}
                            key={el.coach_type_id}>
                            {el.coach_type_name}
                        </div>
                    })}
                </div>

            </div>

            <div className={s.choose_number}>
                <h3>Выберите номер судьи</h3>
                <div className={s.choose_number_box}>
                    {maxCoach(selectedValues.coachMax || 5).map((el, i) => <div key={el}
                                                                                onClick={() => setSelectedValues({
                                                                                    ...selectedValues,
                                                                                    coach_type_number: el + 1
                                                                                })}
                                                                                className={classNames(s.choose_number_item, selectedValues.coach_type_number === el + 1 && s.active)}>{el + 1}</div>)}
                </div>
            </div>

            <div className={s.btn_box}>
                <Button variant="contained" onClick={() => {
                    mainChooseHandler('click')
                }} sx={{
                    minHeight: '52px',
                    minWidth: '240px',
                }}>
                    <CheckIcon sx={{fontSize: 60}}/>
                </Button>
            </div>

        </div>
    );
};

export default Login;
